module.exports = __webpack_public_path__ + "img/3-1.7b606607.svg";